import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserFacade } from '@app/store/user';
import { filter } from 'rxjs';
import { PriceFacade } from '../facades/price.facade';

export const chainPriceLoaded = (): CanActivateFn => {
    return () => {
        const priceFacade = inject(PriceFacade);
        const userFacade = inject(UserFacade);

        priceFacade.getChainPrice(userFacade.user.chain.id);

        return priceFacade.chainPriceIsLoaded$.pipe(filter((loaded) => loaded === true));
    };
};
